module.exports = __webpack_public_path__ + "img/08_1_2_2.e9a19191.png";